import { getConfig } from "@/getConfig";
import { useAuth } from "@/lib/auth";
import { TEST_IDS } from "@/testIdDefinition";
import { useState } from "react";
import { Alert, View } from "react-native";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Text } from "../components/ui/text";
import { Card, CardContent } from "./ui/card";

export default function DebugEnvironment() {
    const { signInWithLocal, isSigningIn } = useAuth();
    const s4pServerUrl = getConfig("s4pServerUrl");
    const isLocalhost =
        s4pServerUrl &&
        (s4pServerUrl.startsWith("http://localhost") ||
            s4pServerUrl.startsWith("http://192.168.") ||
            s4pServerUrl.startsWith("http://10.0."));
    const isQuickDevLoginEnabled =
        process.env.EXPO_PUBLIC_QUICK_DEV_LOGIN_NAME &&
        process.env.EXPO_PUBLIC_QUICK_DEV_LOGIN_PASSWORD &&
        isLocalhost;
    const [devLoginEmail, setDevLoginEmail] = useState("");
    const [devLoginPassword, setDevLoginPassword] = useState("");

    // Used only in tests against the DEV server
    const devLoginEnabled =
        getConfig("env") === "dev" &&
        (isLocalhost || s4pServerUrl === "https://s4p-dev.spork.school");

    async function handleQuickDevLogin() {
        try {
            await signInWithLocal(
                process.env.EXPO_PUBLIC_QUICK_DEV_LOGIN_NAME!,
                process.env.EXPO_PUBLIC_QUICK_DEV_LOGIN_PASSWORD!,
            );
        } catch (error) {
            Alert.alert("Dev login failed:", (error as Error).message);
        }
    }

    async function handleDevLogin() {
        const email = devLoginEmail.trim();
        const password = devLoginPassword;
        if (!email || !password) {
            Alert.alert("Please enter an email and password");
            return;
        }
        try {
            await signInWithLocal(email, password);
        } catch (error) {
            Alert.alert("Dev login failed:", (error as Error).message);
        }
    }

    return !getConfig("env") || getConfig("env") !== "prod" ? (
        <Card className="mx-4 mb-4">
            <CardContent className="flex flex-col items-center gap-2">
                <Text className="text-xs text-muted-foreground mr-4">
                    🚀 Server: {s4pServerUrl}
                </Text>
                {isQuickDevLoginEnabled && (
                    <Button
                        variant="secondary"
                        className=""
                        onPress={handleQuickDevLogin}
                        disabled={isSigningIn}
                    >
                        <Text>
                            DEV login:{" "}
                            {process.env.EXPO_PUBLIC_QUICK_DEV_LOGIN_NAME}
                        </Text>
                    </Button>
                )}
                {devLoginEnabled && (
                    <View className="flex-row flex-wrap gap-2">
                        <Input
                            testID={TEST_IDS[TEST_IDS.DEV_LOGIN_EMAIL_INPUT]}
                            placeholder="Email"
                            value={devLoginEmail}
                            onChangeText={setDevLoginEmail}
                            autoCapitalize="none"
                            keyboardType="email-address"
                            autoComplete="email"
                        />
                        <Input
                            testID={TEST_IDS[TEST_IDS.DEV_LOGIN_PASSWORD_INPUT]}
                            placeholder="Password"
                            value={devLoginPassword}
                            onChangeText={setDevLoginPassword}
                            secureTextEntry
                            autoComplete="password"
                        />
                        <Button
                            testID={TEST_IDS[TEST_IDS.DEV_LOGIN_BUTTON]}
                            variant="secondary"
                            className=""
                            onPress={handleDevLogin}
                            disabled={isSigningIn}
                        >
                            <Text>Dev login</Text>
                        </Button>
                    </View>
                )}
            </CardContent>
        </Card>
    ) : null;
}
